export default __webpack_public_path__ + "static/media/Upload Icon.53aaf519.svg";